import { CreditCardContactInfo } from './credit-card-contact-info.model';
import { GatewayTokenDto } from './gateway-token.dto';

export class CreditCardPaymentInfo {
  public Id: number;
  public TranDate: Date;
  public CardType: string;
  public Amount: number;
  public PurchaseDescr: string;
  public ManuallyProcessed: boolean;
  public ProfileId: number;
  public ValidThruMonth: number;
  public ValidThruYear: number;
  public CardNum: string;
  public SecurityCode: string;
  public CCGatewayID: number;
  public TestMode: boolean;
  public InvoiceNumber: number;
  public ChangedBy: string;

  public CreditCardContactInfo: CreditCardContactInfo = new CreditCardContactInfo();
  public GatewayTokens: GatewayTokenDto[] = [];

  public constructor() {
    let dte = new Date();
    this.Id = 0;
    this.TranDate = new Date();
    this.CardType = '';
    this.Amount = 0;
    this.PurchaseDescr = '';
    this.ManuallyProcessed = false;
    this.ProfileId = 0;
    this.ValidThruMonth = dte.getMonth() + 1;
    this.ValidThruYear = dte.getFullYear();
    this.CardNum = '';
    this.SecurityCode = '';
    this.CCGatewayID = 0;
    this.TestMode = false;
    this.InvoiceNumber = 0;
    this.ChangedBy = '';
  }
}
